import _ from 'underscore';
import { EffectChoiceKey } from '@bingads-webui-campaign/media-common-utils';

/*
Example valid model:
{
  effectSettings: {
    effectKey: 'xxx',
    effectOptions: {
      backgroundBlur: 30,
      backgroundColor: '91, 113, 129',
      designerEffect: '',
    },
  },
}
*/
// used when serializing
export const imageAssetSerializeSchema = {
  type: 'object',
  name: 'ImageAssetSerializeSchema',
  properties: {
    effectSettings: {
      type: 'object',
      alias: 'effect',
      nullable: false,
      properties: {
        effectKey: {
          type: 'string',
          alias: 'key',
          name: 'EffectKey',
          nullable: false,
          enum: [
            EffectChoiceKey.DesignerEffects,
            EffectChoiceKey.BackgroundBlur,
            EffectChoiceKey.BackgroundSolidColor,
          ],
        },
        effectOptions: {
          type: 'object',
          alias: 'ops',
          name: 'EffectOptions',
          nullable: false,
          properties: {
            designerEffect: {
              type: 'string',
              alias: 'dsgEft',
              name: 'DesignerEffectName',
              effectKey: [EffectChoiceKey.DesignerEffects],
              nullable: true,
            },
            backgroundBlur: {
              type: 'number',
              alias: 'bgBlur',
              name: 'BackgroundBlurAmount',
              minimum: 1,
              maximum: 100,
              effectKey: [EffectChoiceKey.BackgroundBlur],
              nullable: true,
            },
            backgroundColor: {
              type: 'string',
              alias: 'bgColor',
              name: 'BackgroundColorValue',
              custom: 'color',
              effectKey: [EffectChoiceKey.BackgroundSolidColor],
              nullable: true,
            },
          },
        },
      },
    },
  },
};

const invertSchemaAlias = schemaProperties =>
  _.reduce(schemaProperties, (memo, val, key) => {
    const newKey = val.alias;
    const newVal = { alias: key };
    if (val.properties) {
      newVal.properties = invertSchemaAlias(val.properties);
    }

    return {
      ...memo,
      [newKey]: newVal,
    };
  }, {});

export const imageAssetDeserializeSchema = {
  type: 'object',
  name: 'ImageAssetDeserializeSchema',
  properties: invertSchemaAlias(imageAssetSerializeSchema.properties),
};
